import React, { useState } from 'react';

/**
 * LobbyScreen Component (Guest Only)
 * Displays meeting details and prompts for a name to join.
 *
 * @param {object} props
 * @param {function} props.onJoin - Callback function to join the meeting. Receives the guest's name.
 * @param {object} props.meetingDetails - Object with details about the meeting (e.g., name, description).
 */
const LobbyScreen = ({ onJoin, meetingDetails }) => {
    // State to hold the guest's name from the input field.
    const [guestName, setGuestName] = useState('');

    // Show a loading message if meeting details haven't arrived yet.
    if (!meetingDetails) {
        return <div>Loading meeting info...</div>;
    }

    // This function handles the form submission.
    const handleJoin = (e) => {
        e.preventDefault(); // Prevent form from reloading the page
        if (guestName.trim()) { // Make sure the name isn't empty
            onJoin(guestName); // Call the parent's join function with the name
        } else {
            // In a real app, you might show a more elegant error message.
            alert("Please enter your name to join.");
        }
    };

    // Basic styling for the component
    const styles = {
        container: { padding: '2rem', textAlign: 'center', color: '#E5E7EB', background: '#1F2937', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
        title: { fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem' },
        description: { marginBottom: '2rem', color: '#9CA3AF' },
        button: { padding: '0.8rem 1.5rem', fontSize: '1.1rem', cursor: 'pointer', background: '#2563EB', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600' },
        input: { width: '100%', maxWidth: '300px', padding: '0.8rem', borderRadius: '5px', border: '1px solid #4B5563', background: '#374151', color: 'white', fontSize: '1rem', marginBottom: '1rem' },
        form: { display: 'flex', flexDirection: 'column', alignItems: 'center' }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>{meetingDetails.name}</h1>
            <p style={styles.description}>{meetingDetails.description || 'Ready to join the meeting?'}</p>

            {/* Form to enter guest name */}
            <form onSubmit={handleJoin} style={styles.form}>
                <label htmlFor="guest-name" style={{ marginBottom: '0.5rem' }}>Enter your name to join:</label>
                <input
                    id="guest-name"
                    type="text"
                    value={guestName}
                    onChange={(e) => setGuestName(e.target.value)}
                    placeholder="Your Name"
                    style={styles.input}
                    required
                    aria-label="Enter your name to join"
                />
                <button type="submit" style={styles.button}>
                    Join Meeting
                </button>
            </form>
        </div>
    );
};

export default LobbyScreen;
